export default __webpack_public_path__ + "static/media/no_apps_found.fdaaa413.svg";